import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { CheckCircle2, Loader2 } from "lucide-react";

export const GuestClaim = ({ sessionId, email, needsPassword }) => {
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { refresh } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/public/claim", { session_id: sessionId, password, name });
      if (data.token) localStorage.setItem("token", data.token);
      await refresh();
      navigate("/library");
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Please try again.");
      setBusy(false);
    }
  };

  return (
    <div className="text-center" data-testid="guest-claim">
      <CheckCircle2 className="h-12 w-12 mx-auto text-accent" strokeWidth={1.5} />
      <h1 className="font-display text-4xl mt-6">Order complete.</h1>
      <p className="text-sm text-muted-foreground mt-3 italic">
        Your book is saved to the library for <span className="not-italic font-medium text-foreground" data-testid="guest-claim-email">{email}</span> and a receipt is on its way.
      </p>
      {needsPassword ? (
        <form onSubmit={submit} className="mt-8 text-left border border-border bg-card p-6 space-y-4" data-testid="guest-claim-form">
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Set a password to download</div>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name (optional)"
            className="w-full border border-border rounded-sm px-3 py-2.5 text-sm bg-background" data-testid="guest-claim-name" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Choose a password (8+ characters)"
            className="w-full border border-border rounded-sm px-3 py-2.5 text-sm bg-background" data-testid="guest-claim-password" />
          {error && <p className="text-sm text-destructive" data-testid="guest-claim-error">{error}</p>}
          <button disabled={busy} className="w-full bg-primary text-primary-foreground py-2.5 text-sm rounded-sm uppercase tracking-wide flex items-center justify-center gap-2 disabled:opacity-60" data-testid="guest-claim-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Open my library
          </button>
        </form>
      ) : (
        <div className="mt-8">
          <Link to="/login" className="bg-primary text-primary-foreground px-5 py-2.5 text-sm rounded-sm uppercase tracking-wide" data-testid="guest-signin-cta">Sign in to download</Link>
        </div>
      )}
    </div>
  );
};
